import React from 'react';
import {Typography} from '@nzpost/react-components';
import {useParams} from "react-router-dom";
import { ReactBarcode } from 'react-jsbarcode';
import "./SuccessPage.css"
import ReactGA from "react-ga4";

export default () => {
  const {orderReference} = useParams();

  React.useEffect(() => {

    ReactGA.event({
      category: "das_success_page_view",
      action: "das_success_page_view",
      label: `DAS Success page view`
    });

    const onBeforeUnload = (e) => {
      e.preventDefault();
      // Included for legacy support, e.g. Chrome/Edge < 119
      e.returnValue = true;
    }
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
    };
  }, []);

  return (
    <div id="nzpost-web-eship-prototype" className="root-wrapper successPage">
      <div className='h1'>
        Show your barcode at the counter
      </div>
      <div className="success-card">
        <p className='body1'>
          Take your parcel to the counter and show the NZ Post agent your barcode.
        </p>
        <p className='body1'>
          The agent will help you select your sending service and pay.
        </p>
        <ReactBarcode style={{width: "100%"}} value={orderReference} options={{
          format: "CODE128",
          ean128: true
        }} renderer="svg" className="barcode"/>
      </div>
      <iframe className="survey" src={process.env.REACT_APP_SURVEY_LINK} />
    </div>
  );
}